export enum TipoFavorito {
  STAKEHOLDER = 'STAKEHOLDER',
  FATO = 'FATO',
}
